import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportProfile } from '../../types/import';
import { EndpointResponse } from '../../types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (importProfileId: number) => {
  if (!importProfileId) {
    throw new Error('`importProfileId` is required');
  }
};

type RequestParams = {
  importProfileId: number;
};

type Response = DBImportProfile | null;

export const getImportProfileById = async (
  scope: RequestScope,
  { importProfileId }: RequestParams,
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importProfileId);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`import_profile/${importProfileId}`, requestOptions);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
